const Header = () => {
  return (
    <header role="banner">
      <a href="/">
        <h1>IMDb episode ratings</h1>
      </a>
    </header>
  );
};

export default Header;
